export default "__VITE_ASSET__DBS3xvYX__"